/** Keep the local-reference fragment marker out of HTTP query parameters.
 * OpenNext rebuilds decoded query values into URLs, where # starts a fragment.
 * The endpoint accepts a plain JSON pointer and restores # for schema resolution.
 */
export function schemaRequestUrl(source: string, pointer: string, offset = 0) {
  return `/api/docs/nexum/schema?${new URLSearchParams({
    source,
    pointer: pointer.slice(1),
    offset: String(offset),
  })}`;
}
